import useLocalStore from '../../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import FJFilterType from './FJFilterType';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
const FJFilterTypeContainer = props => {
    const { embedded } = props;
    const dispatch = useDispatch();
    useLocalStore();
    const communityTypes = useSelector(state => state.community.communityTypes);
    const curCommunityType = useSelector(state => state.community.curCommunityType);
    const curCommunityCategory = useSelector(state => state.community.curCommunityCategory);
    const curCommunitySortType = useSelector(state => state.community.curCommunitySortType);

    const onChangeType = useCallback(
        type => {
            dispatch(FJActionCommunity.changeCommunityTypeAction(type));
        },
        [dispatch],
    );
    const onChangeCategory = useCallback(
        category => {
            dispatch(FJActionCommunity.changeCategoryTypeAction(category));
        },
        [dispatch],
    );
    const onChangeSortType = useCallback(
        sortType => {
            dispatch(FJActionCommunity.changeSortTypeAction(sortType));
        },
        [dispatch],
    );
    return (
        <FJFilterType
            communityTypes={communityTypes}
            curCommunityType={curCommunityType}
            curCommunityCategory={curCommunityCategory}
            onChangeType={onChangeType}
            onChangeCategory={onChangeCategory}
            onChangeSortType={onChangeSortType}
            embedded={embedded}
            curCommunitySortType={curCommunitySortType}
        />
    );
};

FJFilterTypeContainer.propTypes = {
    embedded: PropTypes.bool,
};
export default FJFilterTypeContainer;
